module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chevron_left-red-b47d0129c41796be725cda45b46f2f4d.svg";